// Don't use this file in client components

export const allowedDomains = [
  'fortune.com',
  'develop.fortune.com',
  'images.parsely.com',
  'content.fortune.com',
  'content-develop.fortune.com',
  'content-qa.fortune.com',
  'd2byebo1j9i40c.cloudfront.net',
  'www.brimg.net',
];
